require('./services/amount-commission');

module.exports = 'amount-commission';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/amount-commission/index.js
 ** module id = 68
 ** module chunks = 1
 **/